<template>
  <div id="roles-list" class="roles-list-container">
    <vs-table
      ref="table"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="roles"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            v-if="canSee('add')"
            class="
              p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
              text-lg font-medium text-base text-primary border border-solid border-primary
            "
            @click="addNewData"
          >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                    roles.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : roles.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.display_name }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                v-if="canSee('update')"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr.id)"
              />
              <feather-icon
                v-if="tr.name !== 'administrador' && tr.name !== 'atendente' && canSee('delete')"
                icon="TrashIcon"
                svgClasses="w-5 h-5 ml-3 hover:text-primary stroke-current"
                @click.stop="removeRoleModal(tr.id)"
              />
            </vs-td>
            <!-- <template class="expand-role" slot="expand">
              <table-roles
                :users="tr.users || []"
              />
            </template> -->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-popup
      title="Você realmente deseja fazer isso?"
      :active.sync="removePopupActivated"
      >
        <p>
        Você deseja realmente deletar a permissão?
        </p>

      <vs-button
        color="rgb(62, 201, 214)"
        type="filled"
        class="align-right"
        @click.prevent="deleteData(roleId)"
      >
        <span>Sim</span>
      </vs-button>
    </vs-popup>
  </div>
</template>

<script>
  import { formatRouteTenantPath, hasPermission } from '@/utils'
  import moduleRole from '@/store/role/moduleRole'
  import TableRoles from './TableRoles'

  export default {
    name: 'roles-list',
    data() {
      return {
        selected: [],
        itemsPerPage: 4,
        isMounted: false,
        removePopupActivated: false,
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }

        return 0
      },
      roles() {
        return this.$store.state.role.roles
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.roles.length
      }
    },
    methods: {
      addNewData() {
        this.$router.push(formatRouteTenantPath(`/roles/add`))
      },
      deleteData(roleId) {
        this.$store.dispatch("role/delete", roleId)
        .catch(err => { console.error(err) })
        this.removePopupActivated = false;
        this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Permissão deletada com sucesso!'
        });
      },
      editData(roleId) {
        this.$router.push(formatRouteTenantPath(`/roles/edit/${roleId}`))
      },
      canSee(action) {
        return hasPermission(`roles-${action}`)
      },
      removeRoleModal(roleId) {
        this.roleId = roleId;
        this.removePopupActivated = true;
      },
    },
    created() {
      if (!moduleRole.isRegistered) {
        this.$store.registerModule('role', moduleRole)
        moduleRole.isRegistered = true
      }

      this.$store.dispatch("role/fetch")
    },
    mounted() {
      this.isMounted = true;
    },
    beforeRouteLeave(to, from, next) {
      if (this.removePopupActivated) {
          this.removePopupActivated = false;
          setTimeout( ()=> {
          next();
          }, 2);
      }
      else {
          next();
      }
    },
    components: {
      TableRoles
    }
  }
</script>

<style lang="scss">
  #roles-list {
    .vs-con-table {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
